import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {CompetitionHighlightsPageConfig} from "./competition-highlights-page.config";
import {CompetitionHighlightsPageHandlers} from "./handlers/competition-highlights-page.handlers";
import {CompetitionHighlightsPageStore} from "./competition-highlights-page.store";

export class CompetitionHighlightsPageController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, CompetitionHighlightsPageConfig, CompetitionHighlightsPageStore, CompetitionHighlightsPageHandlers];
}
